export default __webpack_public_path__ + "static/media/blogImage3.faeaff90.jpg";